interface FieldPosition {
  x: number;
  y: number;
}

export function isFieldsPositionValid(fields: FieldPosition[]): boolean {
  return fields.every(({ x, y }) => x >= 0 && x <= 1 && y >= 0 && y <= 1);
}
